import React from 'react'
import { IconButton, makeStyles, useScrollTrigger, Zoom } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PropTypes from 'prop-types';

import { COLORS_PROJECT } from '../../constants';

const {color_button_gis}= COLORS_PROJECT;
const useStyles = makeStyles((theme) => ({
    toTop: {
        zIndex: 2,
        position: "fixed",
        bottom: '2vh',
        backgroundColor: color_button_gis,
        color: 'black',
        "&hover, &.Mui-focusVisible":{
            transition: '0.3s',
            color: 'green',
            backgroundColor: color_button_gis,
        },
        right: '5%'
    }
}));

export const ScrollTop = ({dashboardReference}) => {
    
    
    const trigger = useScrollTrigger({
        target: dashboardReference ? dashboardReference: undefined,
        disableHysteresis: true,
        threshold: 150,
      });

    const classes = useStyles()

    const handleClick = (event) => {
        const anchor = (event.target.ownerDocument || document).querySelector(
          "#GIS"
        );
    
        if (anchor) {
          anchor.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    

    return (
        <Zoom in={trigger}>
            
                <IconButton onClick={handleClick} className={classes.toTop}>
                    <LocationOnIcon />
                </IconButton>
            
        </Zoom>
    )
}


ScrollTop.prototype = {
    dashboardReference: PropTypes.node.isRequired,
}

